import React from 'react';
import Left from '../svg/left';
import Right from '../svg/rigth';

interface PaginationProps {
    currentPage: number;
    pageCount: number;
    onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, pageCount, onPageChange }) => {
    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        
        if (pageCount <= maxVisiblePages) {
            for (let i = 1; i <= pageCount; i++) {
                pages.push(i);
            }
        } else {
            let startPage = Math.max(1, currentPage - 2);
            let endPage = Math.min(pageCount, startPage + maxVisiblePages - 1);
            
            if (endPage - startPage + 1 < maxVisiblePages) {
                startPage = endPage - maxVisiblePages + 1;
            }
            
            if (startPage > 1) {
                pages.push(1);
                if (startPage > 2) {
                    pages.push(-1); // Эллипсис
                }
            }
            
            for (let i = startPage; i <= endPage; i++) {
                if (i > 0 && i <= pageCount) {
                    pages.push(i);
                }
            }
            
            if (endPage < pageCount) {
                if (endPage < pageCount - 1) {
                    pages.push(-1); // Эллипсис
                }
                pages.push(pageCount);
            }
        }
        
        return pages;
    };

    return (
        <div className='flex justify-center gap-[16px]'>
            <button 
                className='w-[40px] h-[40px] flex items-center justify-center border-[1.5px] border-solid border-gray-100 rounded-[8px] text-[16px] text-gray-700 font-medium disabled:opacity-50'
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                <Left />
            </button>

            {getPageNumbers().map((page, index) => (
                page === -1 ? (
                    <span key={`ellipsis-${index}`} className="flex items-end px-2">...</span>
                ) : (
                    <button
                        key={page}
                        className={`w-[40px] h-[40px] flex items-center justify-center border-[1.5px] border-solid rounded-[8px] text-[16px] font-medium ${
                            currentPage === page 
                                ? 'border-[#3B49C0] text-[#3B49C0]' 
                                : 'border-gray-100 text-gray-700'
                        }`}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </button>
                )
            ))}

            <button 
                className='w-[40px] h-[40px] flex items-center justify-center border-[1.5px] border-solid border-gray-100 rounded-[8px] text-[16px] text-gray-700 font-medium disabled:opacity-50'
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === pageCount}
            >
                <Right />
            </button>
        </div>
    )
}

export default Pagination;